/**
 * Fetcher FERP - ERP财务模块接口
 * @author chensi
 */

import { Fetcher } from '@components/bases/Fetcher';
import MenuPathTree from '@fetchers/datas/MenuPathTree';

export class FERP extends Fetcher {
    constructor() {
        super({
            urlPrefix: ['/api/ERP/', '/lpg/admin/erp/'],
            mockPath: MenuPathTree.projectName,
        });
    }

    // 获取物品类型列表（物品类型）
    getGoodsTypeList(search, pagination, sorter) {
        const url = this.spellURL('getGoodsTypeList', '../Goods/getGoodsTypeList');
        const send = {
            ...this.transKeyName('underline', {
                ...search,
                page: pagination.current,
                pageSize: pagination.pageSize,
            }),
            sortBy: sorter?.field,
            sortOrder: sorter?.order,
        };
        return this.post(url, send);
    }

    // 获取物品类型列表 - 下拉框选项
    getGoodsTypeSelectList() {
        const url = this.spellURL('getGoodsTypeList', '../Goods/getGoodsTypeScreen');
        return this.post(url);
    }

    // 添加物品类型（物品类型）
    saveAddArticleTypes(data) {
        const url = this.spellURL('saveAddArticleTypes', '../Goods/addGoodsType');
        const send = {
            ...this.transKeyName('underline', {
                ...data,
            }),
        };
        return this.post(url, send);
    }

    // 编辑物品类型（物品类型）
    saveEditArticleTypes(data) {
        const url = this.spellURL('saveEditArticleTypes', '../Goods/editGoodsType');
        const send = {
            ...this.transKeyName('underline', {
                ...data,
            }),
        };
        return this.post(url, send);
    }

    // 获取物品规格列表（物品规格）
    getGoodsSpecList(search, pagination, sorter) {
        const url = this.spellURL('getGoodsSpecList', '../Goods/getGoodsSpecList');
        const send = {
            ...this.transKeyName('underline', {
                ...search,
                page: pagination.current,
                pageSize: pagination.pageSize,
            }),
            sortBy: sorter?.field,
            sortOrder: sorter?.order,
        };
        return this.post(url, send);
    }

    // 获取物品规格列表 - 下拉框选项
    getGoodsSpecSelectList() {
        const url = this.spellURL('getGoodsSpecList', '../Goods/getGoodsSpecScreen');
        return this.post(url);
    }

    // 添加物品规格（物品规格）
    saveAddArticleSpec(data) {
        const url = this.spellURL('saveAddArticleSpec', '../Goods/addGoodsSpec');
        const send = {
            ...this.transKeyName('underline', {
                ...data,
            }),
        };
        return this.post(url, send);
    }

    // 编辑物品规格（物品规格）
    saveEditArticleSpec(data) {
        const url = this.spellURL('saveEditArticleSpec', '../Goods/editGoodsSpec');
        const send = {
            ...this.transKeyName('underline', {
                ...data,
            }),
        };
        return this.post(url, send);
    }

    // 获取物品列表（物品管理）
    getGoodsList(search, pagination, sorter) {
        const url = this.spellURL('getGoodsList', '../Goods/getGoodsList');
        const send = {
            ...this.transKeyName('underline', {
                ...search,
                page: pagination.current,
                pageSize: pagination.pageSize,
            }),
            sortBy: sorter?.field,
            sortOrder: sorter?.order,
        };
        return this.post(url, send);
    }

    // 获取物品列表 - 下拉框选项
    getGoodsSelectList() {
        const url = this.spellURL('getGoodsSelectList', '../deposit/getErpGoodsList');
        return this.post(url);
    }

    // 添加物品（物品管理）
    saveAddArticle(data) {
        const url = this.spellURL('saveAddArticle', '../Goods/addGoods');
        const send = {
            ...this.transKeyName('underline', {
                ...data,
            }),
        };
        return this.post(url, send);
    }

    // 编辑物品（物品管理）
    saveEditArticle(data) {
        const url = this.spellURL('saveEditArticle', '../Goods/editGoods');
        const send = {
            ...this.transKeyName('underline', {
                ...data,
            }),
        };
        return this.post(url, send);
    }

    // 获取供应商列表（供应商管理）
    getSupplierList(search, pagination, sorter) {
        const url = this.spellURL('getSupplierList', '../Supplier/getSupplierList');
        const send = {
            ...this.transKeyName('underline', {
                ...search,
                page: pagination.current,
                pageSize: pagination.pageSize,
            }),
            sortBy: sorter?.field,
            sortOrder: sorter?.order,
        };
        return this.post(url, send);
    }

    // 添加供应商（供应商管理）
    saveAddSupplier(data) {
        const url = this.spellURL('saveAddSupplier', '../Supplier/addSupplier');
        const send = {
            ...this.transKeyName('underline', {
                ...data,
            }),
        };
        return this.post(url, send);
    }

    // 编辑供应商（供应商管理）
    saveEditSupplier(data) {
        const url = this.spellURL('saveEditSupplier', '../Supplier/editSupplier');
        const send = {
            ...this.transKeyName('underline', {
                ...data,
            }),
        };
        return this.post(url, send);
    }

    // 获取仓库列表（仓库管理）
    getWareHouseList(search, pagination, sorter) {
        const url = this.spellURL('getWareHouseList', 'warehouse/warehouseList');
        const send = {
            ...this.transKeyName('underline', {
                ...search,
                pageNum: pagination.current,
                pageSize: pagination.pageSize,
            }),
            sortBy: sorter?.field,
            sortOrder: sorter?.order,
        };
        return this.post(url, send);
    }

    // 保存仓库（仓库管理）
    saveWareHouse(data) {
        const url = this.spellURL('saveWareHouse', 'warehouse/setWarehouseInfo');
        const send = {
            ...this.transKeyName('underline', {
                ...data,
            }),
        };
        return this.post(url, send);
    }

    //删除仓库（仓库管理）
    saveDelWareHouse(data) {
        const url = this.spellURL('saveDelWareHouse', 'warehouse/deleteWarehouseInfo');
        const send = {
            ...this.transKeyName('underline', {
                ...data,
            }),
        };
        return this.post(url, send);
    }

    //保存出库单（销售出库、其他出库）
    saveOutboundOrder(data) {
        const url = this.spellURL('saveOutboundOrder', 'outWarehouse/setOutWarehouse');
        const send = {
            ...this.transKeyName('underline', {
                ...data,
            }),
        };
        return this.post(url, send);
    }

    // 获取其他出库库存量（其他出库）
    getGoodsExistingNum(data) {
        const url = this.spellURL('getGoodsExistingNum', 'inventory/stockQuantity');
        const send = {
            ...this.transKeyName('underline', {
                ...data,
            }),
        };
        return this.post(url, send);
    }

    // 获取销售出库单列表（出库单列表）
    getOutboundOrder(search, pagination, sorter) {
        const url = this.spellURL('getOutboundOrder', 'outWarehouse/getList');
        const send = {
            ...this.transKeyName('underline', {
                ...search,
                pageNum: pagination.current,
                pageSize: pagination.pageSize,
            }),
            sortBy: sorter?.field,
            sortOrder: sorter?.order,
        };
        return this.post(url, send);
    }

    // 获取销售出库单详情（出库单列表）
    getSalesOutboundOrderDetail(data) {
        const url = this.spellURL('getSalesOutboundOrderDetail', 'outWarehouse/getInfo');
        const send = {
            ...this.transKeyName('underline', {
                ...data,
            }),
        };
        return this.post(url, send);
    }

    // 保存采购入库单
    savePurchaseInbound(data) {
        const url = this.spellURL('savePurchaseInbound', 'inWarehouse/setInWarehouse');
        const send = {
            ...this.transKeyName('underline', {
                ...data,
            }),
        };
        return this.post(url, send);
    }

    // 保存其他入库单
    saveOtherInbound(data) {
        const url = this.spellURL('saveOtherInbound', 'inWarehouse/setInWarehouse');
        const send = {
            ...this.transKeyName('underline', {
                ...data,
            }),
        };
        return this.post(url, send);
    }

    // 获取仓库列表 - 下拉框选项
    getWareHouseSelectList() {
        const url = this.spellURL('getWareHouseSelectList', 'warehouse/getWarehouseOptions');
        return this.post(url);
    }

    // 获取入库单列表（入库单列表）
    getInboundList(search, pagination, sorter) {
        const url = this.spellURL('getInboundList', 'inWarehouse/getList');
        const send = {
            ...this.transKeyName('underline', {
                ...search,
                page: pagination.current,
                pageSize: pagination.pageSize,
            }),
            sortBy: sorter?.field,
            sortOrder: sorter?.order,
        };
        return this.post(url, send);
    }

    // 获取入库单详情（入库单列表）
    getInboundDetail(data) {
        const url = this.spellURL('getInboundDetail', 'inWarehouse/getInfo');
        const send = {
            ...this.transKeyName('underline', {
                ...data,
            }),
        };
        return this.post(url, send);
    }

    // 终止入库单（入库单列表）
    saveCancelInbound(data) {
        const url = this.spellURL('saveCancelInbound', 'inWarehouse/close');
        const send = {
            ...this.transKeyName('underline', {
                ...data,
            }),
        };
        return this.post(url, send);
    }

    // 审核入库单（入库单列表）
    saveExamineInbound(data) {
        const url = this.spellURL('saveExamineInbound', 'inWarehouse/check');
        const send = {
            ...this.transKeyName('underline', {
                ...data,
            }),
        };
        return this.post(url, send);
    }

    // 获取出库单详情（出库单列表）
    getOutboundOrderDetail(data) {
        const url = this.spellURL('getOutboundOrderDetail', 'outWarehouse/getInfo');
        const send = {
            ...this.transKeyName('underline', {
                ...data,
            }),
        };
        return this.post(url, send);
    }

    // 终止出库单（出库单列表）
    saveCancelOutbound(data) {
        const url = this.spellURL('saveCancelOutbound', 'outWarehouse/close');
        const send = {
            ...this.transKeyName('underline', {
                ...data,
            }),
        };
        return this.post(url, send);
    }

    // 审核出库单（出库单列表）
    saveExamineOutbound(data) {
        const url = this.spellURL('saveExamineOutbound', 'outWarehouse/check');
        const send = {
            ...this.transKeyName('underline', {
                ...data,
            }),
        };
        return this.post(url, send);
    }

    // 获取库存流水列表（库存流水）
    getInventoryFlowList(search, pagination, sorter) {
        const url = this.spellURL('getInventoryFlowList', 'warehouse/getInventoryFlow');
        const send = {
            ...this.transKeyName('underline', {
                ...search,
                pageNum: pagination.current,
                pageSize: pagination.pageSize,
            }),
            sortBy: sorter?.field,
            sortOrder: sorter?.order,
        };
        return this.post(url, send);
    }

    // 获取收发存汇总（收发存汇总）
    getInventoryStatistics(search, sorter) {
        const url = this.spellURL('getInventoryStatistics', 'warehouse/getInventorySummary');
        const send = {
            ...this.transKeyName('underline', {
                ...search,
            }),
            sortBy: sorter?.field,
            sortOrder: sorter?.order,
        };
        return this.post(url, send);
    }

    // 获取调拨单列表（调拨单列表）
    getTransferList(search, pagination, sorter) {
        const url = this.spellURL('getTransferList', 'inventory/getTransferList');
        const send = {
            ...this.transKeyName('underline', {
                ...search,
                page: pagination.current,
                pageSize: pagination.pageSize,
            }),
            sortBy: sorter?.field,
            sortOrder: sorter?.order,
        };
        return this.post(url, send);
    }

    // 保存调拨（调拨单列表）
    saveTransfer(data) {
        const url = this.spellURL('saveTransfer', 'inventory/createTransfer');
        const send = {
            ...this.transKeyName('underline', {
                ...data,
            }),
        };
        return this.post(url, send);
    }

    // 获取调拨单详情（调拨单列表）
    getTransferDetail(data) {
        const url = this.spellURL('getTransferDetail', 'inventory/getTransferDetail');
        const send = {
            ...this.transKeyName('underline', {
                ...data,
            }),
        };
        return this.post(url, send);
    }

    // 保存调拨修改数量（调拨单列表）
    saveTransferModify(data) {
        const url = this.spellURL('saveTransferModify', 'inventory/updateTransfer');
        const send = {
            ...this.transKeyName('underline', data),
        };
        return this.post(url, send);
    }

    // 确认调拨单（调拨单列表）
    saveTransferConfirm(data) {
        const url = this.spellURL('saveTransferConfirm', 'inventory/confirmTransfer');
        const send = {
            ...this.transKeyName('underline', data),
        };
        return this.post(url, send);
    }

    // 撤销调拨单（调拨单列表）
    saveTransferCancel(data) {
        const url = this.spellURL('saveTransferCancel', 'inventory/cancelTransfer');
        const send = {
            ...this.transKeyName('underline', data),
        };
        return this.post(url, send);
    }
}

export const $fetchERP = new FERP();
